import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchLeaveCalender } from '../../../service/api';

export const getLeaveCalender = createAsyncThunk(
    'leaveCalender/getAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchLeaveCalender();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const leaveCalenderSlice = createSlice({
    name: 'leaveCalender',
    initialState: {
        calenderData: null,
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLeaveCalender.pending,   (state) => { state.isLoading = true;  state.error = null; })
            .addCase(getLeaveCalender.fulfilled, (state, action) => { state.isLoading = false; state.calenderData = action.payload; })
            .addCase(getLeaveCalender.rejected,  (state, action) => { state.isLoading = false; state.error = action.payload; });
    },
});

export default leaveCalenderSlice.reducer;
